import AxiosClient from "../../services/axios.services";

class ClassificationServices {
  getClassifications = (params, iType) =>
    AxiosClient.get(
      iType === 1
        ? "/api/app/Formal_Clasificacion/"
        : "/api/app/Funcional_Clasificacion/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  saveClassification = (data, iType) =>
    AxiosClient.post(
      iType === 1
        ? "/api/app/Formal_Clasificacion/"
        : "/api/app/Funcional_Clasificacion/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editClassification = (id, data, iType) =>
    AxiosClient.put(
      iType === 1
        ? `/api/app/Formal_Clasificacion/${id}/`
        : `/api/app/Funcional_Clasificacion/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteClassification = (id, iType) =>
    AxiosClient.delete(
      iType === 1
        ? `/api/app/Formal_Clasificacion/${id}/`
        : `/api/app/Funcional_Clasificacion/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new ClassificationServices();
